<h2>{{ 'register.manualFlow.modals.editTechnicalSkill' | translate }}</h2>

<form [formGroup]="technicalSkillsForm" class="field-grid">
    <div class="field">
        <label for="edittechnicalSkill">{{ 'register.manualFlow.step4.tool' | translate }}</label>
        <input class="otherInput" id="edittechnicalSkill" formControlName="technicalSkill" [placeholder]="'register.manualFlow.step4.toolPlaceholder' | translate">
        <p class="error-message" *ngIf="technicalSkillsForm.get('technicalSkill')?.invalid && technicalSkillsForm.get('technicalSkill')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
    <div class="field">
        <label for="edittechnicalSkillLevel">{{ 'register.manualFlow.step4.level' | translate }}</label>
        <select class="otherInput" id="edittechnicalSkillLevel" formControlName="technicalSkillLevel" [compareWith]="sameValue">
            <option [ngValue]="''" disabled>{{ 'register.manualFlow.step4.select' | translate }}</option>
            <option *ngFor="let level of skillLevels" [ngValue]="level">{{ 'register.step4.selectLevelNames.' + level.name | translate }}</option>
        </select>
        <p class="error-message" *ngIf="technicalSkillsForm.get('technicalSkillLevel')?.invalid && technicalSkillsForm.get('technicalSkillLevel')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
</form>

<div class="modal-actions">
    <button type="button" class="text-button" (click)="close()">{{ 'register.manualFlow.modals.cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="saveEditTechnicalSkills()">{{ 'register.manualFlow.modals.save' | translate }}</button>
</div>
